/**
 * Codmonステータスラベルディレクティブ
 *
 * @description
 * このディレクティブは、状態を示す小さなラベル（バッジ）を提供します。
 * デザインシステムの StatusLabel コンポーネントに対応します。
 *
 * @example
 * // アプリ未登録などの注意ラベル
 * <codmon-status-label variant="caution">アプリ未登録</codmon-status-label>
 *
 * @example
 * // 更新などの警告ラベル
 * <codmon-status-label variant="warning">更新</codmon-status-label>
 *
 * @example
 * // お知らせなどの情報ラベル
 * <codmon-status-label variant="info">お知らせ</codmon-status-label>
 *
 * @example
 * // デモなどの中立ラベル
 * <codmon-status-label variant="neutral">デモ</codmon-status-label>
 *
 * @property {string} variant - ラベルの種類を指定 (例: caution, warning, info, neutral)
 */
angular.module('inspinia').directive('codmonStatusLabel', () => {
  return {
    restrict: 'E',
    scope: {
      variant: '@',
    },
    transclude: true,
    templateUrl: `/manage/src/view/directive/codmon-ui/codmon_status_label.html?${new Date().getTime()}`,
    link($scope) {
      const variants = ['caution', 'warning', 'info', 'neutral'];
      $scope.variant = variants.includes($scope.variant) ? $scope.variant : 'neutral';

      // variant は不変なのでCSSクラスは一度だけ生成し、同一参照を束縛する（digest毎の再生成を避ける）
      // 基底クラス codmon-status-label はテンプレートの class 属性で付与済みのため variant クラスのみ
      $scope.statusLabelClasses = {
        [`codmon-status-label--${$scope.variant}`]: true,
      };
    },
  };
});
